// extracted by mini-css-extract-plugin
export default {"tabletImg":"hN","desktopImg":"iN","mobileImg":"jN","backgroundImage":"kN","content":"lN","rtbLeft":"mN","rtbRight":"nN","imageContainer":"oN","rtbBox":"pN","line":"qN","rtbLeftMobile":"rN","rtbDesktop":"sN"};
    if(module.hot) {
      // 1737143662507
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  